import React, {useEffect, useRef, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {useAuth} from '../../modules/auth'
import ConnectionTestRequiredModal from './ConnectionTestRequiredModal'
import {fetchConnectionTestStatus} from './api'
import {
  clearConnectionTestSessionDismiss,
  isConnectionTestSessionDismissed,
  markConnectionTestSessionDismiss,
} from './sessionDismiss'

const ConnectionTestGate: React.FC = () => {
  const {currentUser, auth} = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [showPopup, setShowPopup] = useState(false)
  const checkedSessionRef = useRef<string | null>(null)

  const isInterpreter = currentUser?.result?.userType === 'INTERPRETER'
  const userId = currentUser?.result?.code

  useEffect(() => {
    if (!auth?.token || !isInterpreter || !userId) {
      clearConnectionTestSessionDismiss()
      checkedSessionRef.current = null
      setShowPopup(false)
      return
    }

    const sessionKey = `${userId}:${auth.token}`
    if (checkedSessionRef.current === sessionKey) return
    checkedSessionRef.current = sessionKey

    let cancelled = false

    const check = async () => {
      try {
        if (isConnectionTestSessionDismissed(auth.token)) {
          setShowPopup(false)
          return
        }
        const {data} = await fetchConnectionTestStatus()
        if (cancelled) return
        setShowPopup(!data?.connectionTestCompleted)
      } catch {
        setShowPopup(false)
      }
    }

    check()

    return () => {
      cancelled = true
    }
  }, [auth?.token, isInterpreter, userId])

  useEffect(() => {
    if (location.pathname.startsWith('/connection-test')) {
      setShowPopup(false)
    }
  }, [location.pathname])

  if (!isInterpreter) return null

  const handleCancel = () => {
    markConnectionTestSessionDismiss(auth?.token)
    setShowPopup(false)
  }

  const handleConfirm = () => {
    setShowPopup(false)
    navigate('/connection-test')
  }

  return (
    <ConnectionTestRequiredModal
      show={showPopup}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    />
  )
}

export default ConnectionTestGate
